import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Florist = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my florist business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps florist businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for florist businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most florist businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my florist business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like florist. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Florist - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Florist CRM", url: "/industries/florist" }
  ];

  const industryData = {
    name: 'Florist',
    title: 'Capture Holiday Rush Orders & Build Year-Round Subscription Revenue',
    subtitle: 'Automate holiday reminders, manage rush orders efficiently, and create recurring flower subscriptions',
    icon: '💐',
    challenges: [
      'Overwhelmed during holiday rushes',
      'Clients forget special occasions',
      'Hard to build consistent revenue',
      'Missing last-minute rush orders',
      'Manual order tracking is time-consuming'
    ],
    solutions: [
      'Holiday reminder automation increases orders',
      'Special occasion tracking and alerts',
      'Subscription flower service automation',
      'Rush order notification system',
      'Smart order and delivery management'
    ],
    features: [
      'Client CRM with occasion tracking',
      'Automated holiday reminders',
      'Subscription management',
      'Online ordering system',
      'Delivery route optimization',
      'Photo galleries of arrangements',
      'Review automation',
      'Corporate account management'
    ],
    results: [
      '200% more orders during holidays',
      '45% of clients join subscription service',
      'Never miss a special occasion',
      '5.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Florist UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for florist businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for florist UK, florist business software, florist customer management, florist lead generation UK"
        url="/industries/florist"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Florist;